import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { bookingApi } from '../utils/bookingApi';

const monthName = (yyyyMm) => new Date(`${yyyyMm}-15T12:00:00Z`).toLocaleDateString('en-GB', { month: 'long', timeZone: 'UTC' });
// Direct Debit takes days to collect, so a bill isn't called unpaid this soon
const UNPAID_AFTER_MS = 7 * 24 * 60 * 60 * 1000;
const dayMonth = (iso) => new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', timeZone: 'Europe/London' });

// Club admins only: an unpaid Run The Club bill, and when card payments pause
export default function BillingBanner() {
  const { user } = useAuth();
  const applies = user?.role === 'CLUB_ADMIN' && user?.club?.isHouseClub === false;
  const [billing, setBilling] = useState(null);

  useEffect(() => {
    if (!applies) return undefined;
    let live = true;
    bookingApi.getPayouts({ light: true })
      .then(r => { if (live) setBilling(r.data?.billing || null); })
      .catch(() => {}); // a banner is never worth an error
    return () => { live = false; };
  }, [applies, user?.id]);

  if (!applies || !billing) return null;
  const overdue = billing.status === 'OVERDUE';
  const bill = billing.overdueBill;
  const unpaid = bill && Date.now() - new Date(bill.issuedAt).getTime() >= UNPAID_AFTER_MS;
  if (billing.status === 'WAIVED' || (!overdue && !unpaid)) return null;
  return (
    <Link to="/booking/admin/card-payments" className="app-layout__payment-banner">
      <span>
        {overdue
          ? 'Card payments are paused until your bill is paid.'
          : `Your Run The Club bill for ${monthName(bill.month)} is unpaid. Card payments pause on ${dayMonth(bill.pausesOn)}.`}
      </span>
      <span className="app-layout__banner-cta">Open Card payments</span>
    </Link>
  );
}
